'use memo'

import { useFormikContext } from 'formik'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import {
  PLUGIN_FOOTER_LINK_MAX,
  PLUGIN_FOOTER_MODE_OPTIONS,
  PLUGIN_FOOTER_TEXT_MAX,
  type PluginEmbedSettings,
  type PluginFooterMode,
} from '@sportninja/common/features/account/apiAccess'
import { SegmentedInput } from 'src/components/ts-components/SegmentedInput'
import { TextField } from '../../../components/FormikField'
import { PLUGIN_FOOTER_FOR_MODE } from '../../constants/pluginSettings'
import { pluginFooterModeOf } from '../../utils/pluginFooterMode'

const FOOTER_OPTIONS = PLUGIN_FOOTER_MODE_OPTIONS.map(({ label, value }) => ({
  label: capitalizeWords(label),
  value,
}))

/** Branded (the plugin's "Powered by" line), hidden, or the league's own text and optional link. */
export const FooterField = () => {
  const { values, setFieldValue } = useFormikContext<PluginEmbedSettings>()
  const mode = pluginFooterModeOf(values.display.footer)

  return (
    <>
      <SegmentedInput
        label={capitalizeWords('Footer')}
        options={FOOTER_OPTIONS}
        value={mode}
        onChange={(next: PluginFooterMode) =>
          setFieldValue('display.footer', PLUGIN_FOOTER_FOR_MODE[next])
        }
      />
      {mode === 'custom' ? (
        <>
          <TextField
            name='display.footer.text'
            label={capitalizeWords('Footer Text')}
            placeholder={capitalizeWords('Footer Text')}
            hint={`Up to ${PLUGIN_FOOTER_TEXT_MAX} characters, one line`}
          />
          <TextField
            name='display.footer.link'
            label={capitalizeWords('Footer Link')}
            placeholder={capitalizeWords('Footer Link')}
            hint={`Optional; an https link like https://example.com, up to ${PLUGIN_FOOTER_LINK_MAX} characters`}
            emptyValue='unset'
            autoComplete='url'
          />
        </>
      ) : null}
    </>
  )
}
